import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AccountLogic, AccountStateService, EnvironmentService, StaticContentService } from '@mwe/services';
import { APPLICATION_NAME, DEFAULT_POPUP_COMPONENT_TOKEN, ENVIRONMENT_SERVICE_TOKEN, LOCATION_TOKEN } from '@mwe/constants';
import { OAuthModule, OAuthService, UrlHelperService } from 'angular-oauth2-oidc';
import { PopupComponent } from '@mwe/ui/components';
import { BeraterEnvironmentService } from './service/environment/berater-environment.service';
import { keycloakConfig } from './config/keycloak.config';
import { authInterceptor } from './interceptor/auth.interceptor';
import { provideKeycloak } from 'keycloak-angular';
import { LocalStorageService, provideWebstorage, withLocalStorage, withSessionStorage } from '@mwe/utils';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { DROPDOWN_TRANSFORMERS } from '@shared-ikp/app.constants';
import { beraterDropdownTypeMapping } from './utils/ikp-berater-dropdown-transformers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    importProvidersFrom(OAuthModule.forRoot()),
    provideKeycloak({
      config: keycloakConfig,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
      },
    }),
    provideTranslateService({
      lang: 'de',
      loader: provideTranslateHttpLoader({
        prefix: 'assets/i18n/',
        suffix: '.json',
        enforceLoading: true,
      }),
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideWebstorage(withLocalStorage({ delimiter: '_', prefix: 'berater' }), withSessionStorage({ delimiter: '_', prefix: 'ikp' })),
    provideZoneChangeDetection(),
    { provide: APPLICATION_NAME, useValue: 'MWE' },
    { provide: LOCATION_TOKEN, useValue: 'local' },
    { provide: LocalStorageService, useClass: LocalStorageService },
    { provide: AccountStateService, useClass: AccountStateService },
    { provide: EnvironmentService, useClass: BeraterEnvironmentService },
    { provide: ENVIRONMENT_SERVICE_TOKEN, useClass: BeraterEnvironmentService },
    { provide: AccountLogic, useClass: AccountLogic },
    { provide: OAuthService, useClass: OAuthService },
    { provide: UrlHelperService, useClass: UrlHelperService },
    { provide: DEFAULT_POPUP_COMPONENT_TOKEN, useValue: PopupComponent },
    {
      provide: StaticContentService, useValue: {
        getInfoTextList: () => null,
      }
    },
    {
      provide: DROPDOWN_TRANSFORMERS,
      useValue: beraterDropdownTypeMapping,
    },
  ],
};
